import moveItemsBasedOnNodeIds from '../actions/actionCreators/moveItemsBasedOnNodeIds';
import moveItemsFromItemIds from '../actions/move/moveItemsFromItemIds';
import { listViewStore } from 'owa-mail-list-store';
import getItemIdsToShowFromNodeOrThreadIds from 'owa-mail-store/lib/selectors/getItemIdsToShowFromNodeOrThreadIds';
import { orchestrator } from 'satcheljs';
import { selectNextItemPart } from 'owa-mail-actions/lib/mailListSelectionActions';
import { isFirstLevelExpanded } from 'owa-mail-list-store/lib/selectors/isConversationExpanded';

export default orchestrator(moveItemsBasedOnNodeIds, actionMessage => {
    const tableView = listViewStore.tableViews.get(actionMessage.tableViewId);
    const rowKeys = [...tableView.selectedRowKeys.keys()];
    const itemIds = getItemIdsToShowFromNodeOrThreadIds(
        actionMessage.nodeIds,
        isFirstLevelExpanded(rowKeys[0])
    );

    selectNextItemPart(listViewStore.expandedConversationViewState.expandedRowKey, tableView);

    moveItemsFromItemIds(
        itemIds,
        actionMessage.destinationFolderId,
        tableView,
        actionMessage.actionSource
    );
});
